import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';

interface HookProps {
  inline?: boolean;
  estatico?: boolean;
  backgroundTransparent?: boolean;
}

export default makeStyles<Theme, HookProps>(
  (theme) =>
    createStyles({
      root: {
        position: (props) =>
          props.estatico ? 'static' : props.inline ? 'absolute' : 'fixed',
        top: 0,
        left: 0,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        height: '100%',
        backgroundColor: (props) =>
          props.backgroundTransparent
            ? 'rgba(255, 255, 255, 0.0)'
            : 'rgba(255, 255, 255, 0.9)',
        zIndex: 24,
        textAlign: 'center',
        '&.backgroundTransparent': {},
      },
      container: {
        position: 'relative',
        textAlign: 'center',
        width: 100,
      },
      dot: {
        display: 'inline-block',
        width: '1rem',
        height: '1rem',
        borderRadius: '50%',
        margin: 8,
        backgroundColor: '#3fa110',
        '&:nth-child(2)': {
          animationDelay: '-1.1s',
        },
        '&:nth-child(3)': {
          animationDelay: '-0.9s',
        },
      },
      text: {
        fontFamily: '"Exo 2", sans-serif',
        fontSize: 20,
        fontWeight: 500,
        color: theme.palette.primary.main,
        padding: theme.spacing(0, 2),
      },
    }),
  { name: 'LoadingStatus' }
);
